import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchSiteOptions } from "../../redux/actions/siteOptions";
import MaintenancePage from "../../pages/MaintenancePage";
import { SimpleLoader } from "./Loader";

const AdminMaintenanceBanner = () => (
  <div className="sticky top-0 z-[10000] border-b border-amber-300 bg-amber-50 px-4 py-2 text-center text-sm text-amber-950">
    The site is in maintenance mode. Visitors currently see the maintenance page.{" "}
    <Link
      to="/admin/options/maintenance"
      className="font-semibold text-[#38513b] underline hover:text-[#2f4232]"
    >
      Change this in Options
    </Link>
  </div>
);

const MaintenanceGate = ({ children }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { loading: adminLoading, isAuthenticated: isAdmin } = useSelector(
    (state) => state.admin
  );
  const { options, loading } = useSelector((state) => state.siteOptions);
  const globalOptions = options?.global;
  const optionsLoading = Boolean(loading?.global);

  useEffect(() => {
    if (!globalOptions && !optionsLoading) {
      dispatch(fetchSiteOptions("global"));
    }
  }, [dispatch, globalOptions, optionsLoading]);

  if (location.pathname.startsWith("/admin")) {
    return children;
  }

  if (adminLoading || (optionsLoading && !globalOptions)) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#f4f1ea]">
        <SimpleLoader />
      </div>
    );
  }

  const maintenance = globalOptions?.maintenance || {};
  if (maintenance.enabled && !isAdmin) {
    return (
      <MaintenancePage
        settings={maintenance}
        headerLogo={globalOptions?.header?.logo}
      />
    );
  }

  return (
    <>
      {maintenance.enabled && isAdmin ? <AdminMaintenanceBanner /> : null}
      {children}
    </>
  );
};

export default MaintenanceGate;
